import React from "react";
import { client } from "../../../service/ApolloClient/ApolloClient";
import { QUERY_DEBIT_CREDITS_TOTAL } from "../../../service/ApolloClient/ApolloQueries";
import { Box, Button, Card, Grid } from "@material-ui/core";
import { formatString } from "../../UI/react-persian/PersianNumber";

class DebitCreditRowDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      debit: 0,
      credit: 0,
      bounced: 0,
      cached: 0,
      current: 0,
    };

    this.getTotalDebit = this.getTotalDebit.bind(this);
  }

  componentDidMount() {
    this.getTotalDebit();
  }

  getTotalDebit() {
    client
      .query({
        query: QUERY_DEBIT_CREDITS_TOTAL,
        variables: {
          user: this.props.user,
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        const { debit, credit, cached, bounced, current } =
          res.data.DebtCreditsTotalQuery;
        this.setState({
          debit,
          credit,
          cached,
          bounced,
          current,
        });
      });
  }

  render() {
    return (
      <>
        <Card
          style={{
            marginBottom: 10,
          }}
        >
          <Box style={{ display: "flex", justifyContent: "flex-start" }}>
            <Grid container spacing={2}>
              <Grid item xs={10}>
                <Box
                  mr={2}
                  ml={2}
                  mb={4}
                  mt={4}
                  style={{ display: "flex", justifyContent: "space-around" }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <div
                        style={{
                          color: "red",
                          paddingTop: 10,
                          textAlign: "right",
                        }}
                      >
                        چک های پاس نشده : {formatString(this.state.bounced)}
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <div
                        style={{
                          color: "green",
                          paddingTop: 10,
                          textAlign: "right",
                        }}
                      >
                        چک های پاس شده : {formatString(this.state.cached)}
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <div
                        style={{
                          color: "grey",
                          paddingTop: 10,
                          textAlign: "right",
                        }}
                      >
                        چک های جاری : {formatString(this.state.current)}
                      </div>
                    </Grid>
                  </Grid>
                </Box>

                <Box
                  mr={2}
                  ml={2}
                  mb={4}
                  mt={4}
                  style={{ display: "flex", justifyContent: "space-around" }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <div
                        style={{
                          color: "red",
                          paddingTop: 10,
                          textAlign: "right",
                        }}
                      >
                        بدهی : {formatString(this.state.debit)}
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <div
                        style={{
                          color: "green",
                          paddingTop: 10,
                          textAlign: "right",
                        }}
                      >
                        بستانکاری : {formatString(this.state.credit)}
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <div
                        style={{
                          color:
                            this.state.credit - this.state.debit > 0
                              ? "green"
                              : "red",
                          paddingTop: 10,
                          textAlign: "right",
                        }}
                      >
                        مانده :{" "}
                        {formatString(this.state.credit - this.state.debit)}
                      </div>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
              <Grid
                item
                xs={2}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Button
                  type="submit"
                  size={"large"}
                  color={"primary"}
                  variant={"contained"}
                  onClick={(e) => {
                    this.props.openDebit(true);
                  }}
                >
                  افزودن بدهی و طلب
                </Button>
              </Grid>
            </Grid>{" "}
          </Box>
        </Card>
      </>
    );
  }
}

export default DebitCreditRowDetail;
